<template>
    <div class="title layout drag">
        <div class="flex title-value" v-text="title"></div>
        <!--最大化最小化等-->
        <div class="tool no-drag">
            <span class="iconfont el-icon-close no-drag" title="关闭" @click.stop="closeWindow"></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "md-title",
        props:{
            title: { default: '' }
        },
        data() {
            return {
                formState: "normal",//窗口的状态
            }
        },
        methods: {
            closeWindow: function () {//关闭窗口
                window.close();
            }
        }
    }
</script>

<style scoped lang="less">
    .title {
        width: 100%;
        height: 30px;
        background:#F5F1F1;
        border-radius: 2px;
        position: fixed;
        left: 0;
        top: 0;
        .tool {
            background: #F5F1F1;
            position: absolute;
            top: 2px;
            right: 4px;
            width: 26px;
            height: 26px;
            cursor: pointer;
            span {
                color: #444444;
                font-size: 13px;
                display: block;
                width: 26px;
                height: 26px;
                display: flex;
                justify-content: center;
                align-items: center;
                &:hover{
                    background-color: #e1e1e1;
                    border-radius: 50%;
                }
            }
        }
        .title-value {
            cursor: default;
            line-height: 30px;
            color: #333333;
            font-size: 14px;
            text-align: center;
        }
    }

</style>